const DATE_WIDTH = 140;
const cell = { whiteSpace: "nowrap", width: DATE_WIDTH, minWidth: DATE_WIDTH };

export default function dateColumn(title, render) {
  return {
    title,
    width: DATE_WIDTH,
    onCell: () => ({ style: cell }),
    onHeaderCell: () => ({ style: cell }),
    render,
  };
}
